<div class="example-preview">
    <div>
        <ng-template #devolution ngbAutofocus let-c="close" let-d="dismiss">
            <div class="modal-header">
                <h4 class="modal-title">Gerar Documento de Devolução</h4>
                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row rowCustom">
                    <div class="col">
                        <div class="form-group">
                            <label class="form-text" for="responsible"><strong>Favorecido</strong></label>
                            <span class="form-text" id="responsible"> {{ showHide.element.responsibleName }}</span>
                        </div>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label class="form-text" for="entity"><strong>Emitente</strong></label>
                            <span class="form-text" id="entity"> {{ showHide.informBatch.legalEntityName }}</span>
                        </div>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label class="form-text" for="valueDevolution"><strong>Valor á Devolver</strong></label>
                            <span class="form-text" id="valueDevolution">
                                {{ showHide.element.valuePaid | currency }}</span
                            >
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label class="form-text" for="valueDevolution"><strong>Data de Devolução</strong></label>

                            <form class="form-inline">
                                <div class="form-group">
                                    <div class="input-group">
                                        <input
                                            class="form-control"
                                            placeholder="dd/mm/yyyy"
                                            name="dp"
                                            [(ngModel)]="model"
                                            ngbDatepicker
                                            #d="ngbDatepicker" />
                                        <div class="input-group-append">
                                            <button
                                                class="btn btn-outline-secondary calendar"
                                                (click)="d.toggle()"
                                                type="button"></button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <h5 class="text-success">Entidade Legal : para Receb. Antecipado</h5>
                        <table class="table table-bordered table-hover">
                            <thead class="thead-success">
                                <tr>
                                    <th>Entidade Legal</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    class="pointer"
                                    (click)="selectLegalEntity(data)"
                                    [class.selected]="
                                        data.legalEntityId == legalEntityListDevolutionSelected?.legalEntityId
                                    "
                                    *ngFor="let data of legalEntityListDevolution; index as i">
                                    <td>{{ data.name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="c('Close click'); close()">Cancelar</button>
                <button type="button" (click)="confirm()" class="btn btn-primary">Confirmar</button>
            </div>
        </ng-template>

        <ng-template #content7 ngbAutofocus let-c="close" let-d="dismiss">
            <div class="modal-header">
                <h4 class="modal-title">Seleção de pessoa</h4>
                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row rowCustom">
                    <div class="col">
                        <div class="row">
                            <mat-icon class="colorWarning">warning</mat-icon>
                            <p>
                                Não foram encontradas as informações deste boleto. Por favor selecione abaixo um
                                responsável.
                            </p>
                        </div>
                        <search-person-input
                            [searchType]="searchPersonType"
                            (personSelectedId)="personSelected($event)">
                        </search-person-input>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="c('Close click'); close()">Cancelar</button>
            </div>
        </ng-template>
    </div>
</div>
